export enum GoalMessageKeys {
  id = 'id',
  text = 'text',
  authorDbId = 'authorDbId',
  timestamp = 'timestamp',
}

export interface GoalMessage {
  [GoalMessageKeys.id]?: string;
  [GoalMessageKeys.text]: string;
  [GoalMessageKeys.authorDbId]: string;
  [GoalMessageKeys.timestamp]: string;
}

export enum GoalKeys {
  year = 'year',
  amount = 'amount',
  messages = 'messages',
}

export class Goal {
  constructor(year: number, amount: number) {
    this.year = year;
    this.amount = amount;
  }

  [GoalKeys.year]?: number;
  [GoalKeys.amount]?: number;
  [GoalKeys.messages]?: GoalMessage[];
}
